const cartBackLink = document.querySelector('[data-cart-history-back]');

if (cartBackLink) {
  cartBackLink.addEventListener('click', (event) => {
    if (window.history.length <= 1 || !document.referrer) return;

    try {
      const previousUrl = new URL(document.referrer);
      const currentUrl = new URL(window.location.href);
      const isPreviousStorePage = previousUrl.origin === currentUrl.origin;
      const isDifferentPage = previousUrl.pathname !== currentUrl.pathname;

      if (!isPreviousStorePage || !isDifferentPage) return;

      event.preventDefault();
      window.history.back();
    } catch (_error) {
      // The anchor href remains the safe fallback when the referrer is unusable.
    }
  });
}
